import { useEffect, useState } from "react";
import { userRequest } from "../../requestMethods";
import "./widgetLg.css";
import { format } from 'timeago.js';

const WidgetLg = () => {
    const [orders, setOrders] = useState([]);

    useEffect(() => {
        const getOrders = async () => {
            try{
                const res = await userRequest.get("/orders?new=true");
                setOrders(res.data);
            } catch (err) {
                console.log(err);
            }
        };
        getOrders();
    }, []);

    const Button = ({ type }) => {
        return <button className={"widgetLgButton " + type}>{type}</button>
    };

    return (
        <div className="widgetLg">
            <h3 className="widgetLgTitle">Latest transactions</h3>
            <table className="widgetLgTable">
                <tbody>
                    <tr className="widgetLgTr">
                        <th className="widgetLgTh">Customer</th>
                        <th className="widgetLgTh">Date</th>
                        <th className="widgetLgTh">Amount</th>
                        <th className="widgetLgTh">Status</th>
                    </tr>
                    {orders.map(order => (
                        <tr key={order._id} className="widgetLgTr">
                            <td className="widgetLgUser">
                                <span className="widgetLgUsername">{order.userId}</span>
                            </td>
                            <td className="widgetLgDate">{format(order.createdAt)}</td>
                            <td className="widgetLgAmount">$ {order.amount}</td>
                            <td className="widgetLgStatus"><Button type={order.status} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default WidgetLg;
